import { MemdbBoolean, RoleType, SpecialType } from "@ssf/memdb-api";
const hasRequiredRoles = (roles) => [
    RoleType.President,
    RoleType.Secretary,
    RoleType.BoardMember,
    RoleType.ContactPerson,
    RoleType.Accountant,
].every((roleType) => roles.some(({ orgrole }) => orgrole === roleType));
export const getClubStatus = ({ startdate, active, specialType, roles, }, currentYear = new Date().getFullYear()) => {
    const isStartedCurrentYear = startdate.substring(0, 4) === currentYear.toString();
    const isUnapprovedClub = specialType === SpecialType.Temp;
    return {
        isStartedCurrentYear,
        isPreUnapprovedClub: roles && !hasRequiredRoles(roles) && isUnapprovedClub,
        isUnapprovedClub,
        isApprovedClub: active === MemdbBoolean.False && specialType === SpecialType.Default,
        isActiveClub: active === MemdbBoolean.True && specialType === SpecialType.Default,
    };
};
//# sourceMappingURL=getClubStatus.js.map